function Dipespdigitaltransformacion(){
       return(
        <div className="contenedor">
            <div className="presentacion"> 
               <h1> Presentación </h1>
               <p>
                    El Diploma de Especialización en Gobierno Digital y Transformación Digital 
                    brinda formación integral sobre estrategias, herramientas y metodologías 
                    orientadas a la modernización digital de las instituciones públicas.
               </p>
               <p>
                    El programa desarrolla contenidos vinculados a gobierno electrónico, 
                    interoperabilidad, gestión de datos, servicios digitales al ciudadano, 
                    innovación tecnológica, ciberseguridad y estrategias de transformación digital.
               </p>

                <h1> Objetivo Específico </h1>
                <ul>
                    <li>
                        Desarrollar competencias técnicas y estratégicas para implementar 
                        iniciativas de gobierno digital y transformación digital, promoviendo 
                        la modernización de procesos y la mejora de los servicios públicos.
                    </li>
                </ul>
            </div>

            <div className="metedologia">
                <img 
                    src='/uploads/curs_ia_data.webp' 
                    alt='gobierno-digital' 
                    className='logo-metodologia'
                />
                
                <ul> 
                    <li>
                        <h1> Informes </h1>
                        <p>Escuela de Gerencia y Gestión S.A.C</p>
                        <p>📱 Teléfonos y WhatsApp: 913376365 / 948251685</p>
                        <p>📧 Correos: esscuelag@gmail.com | capacita@escuelag.com</p>
                    </li>
                </ul>
            </div>

            <div className="temario-principal">
                <h1> Áreas Temáticas </h1>
                <ul>
                    <li> 1. Gobierno Electrónico </li>
                    <li> 2. Interoperabilidad </li>
                    <li> 3. Gestión de Datos </li>
                    <li> 4. Servicios Digitales al Ciudadano </li>
                    <li> 5. Ciberseguridad </li>
                    <li> 6. Estrategias de Transformación Digital </li>
                </ul>
            </div>
        </div>
    );
}

export default Dipespdigitaltransformacion